<template>
    <!-- Mentions de bas de page des écrans d'authentification : texte blanc
         directement sur la photo, sans bandeau. -->
    <footer class="naef-mentions">
        <p>&copy; {{ annee }} naef.ch, Tous droits réservés.</p>
        <p>
            <a
                href="https://www.naef.ch/protection-des-donnees/"
                target="_blank"
                rel="noopener"
            >Protection des données</a>
        </p>
    </footer>
</template>

<script>
export default {
    computed: {
        annee() {
            return new Date().getFullYear();
        },
    },
};
</script>
